export default __webpack_public_path__ + "static/media/2-SOLUTION-EN.0044ba49.pdf";